package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "de", default = false)
val DeStrings = Strings(
    analyzer = "Analysator",
    appreciationOverview = "Übersicht der Wertentwicklung",
    chartLegendInterest = "Zinsen",
    chartLegendPrincipal = "Kapital",
    chartXaxisMonths = "Monate",
    chartYaxisPayment = "Zahlung",
    code = "de",
    costOfCredit = "Kreditkosten",
    creditDealAnalyzerDescription = "Geben Sie Ihre Kreditdetails ein, um eine umfassende Analyse Ihres Kreditdeals zu erhalten. Unser Analysator bewertet die wichtigsten Kennzahlen, um Ihnen zu helfen, die wahren Kosten Ihres Kredits zu verstehen und eine fundierte Entscheidung zu treffen.",
    detailsGoodRateLongTerm = "Guter Zinssatz, aber lange Laufzeit führt zu hohen Gesamtkosten.",
    detailsHighApr = "Hoher effektiver Jahreszins. ",
    detailsHighInterestCost = "Hohe Gesamtzinskosten.",
    detailsHighRateShortTerm = "Hoher Zinssatz, aber kurze Laufzeit hält die Gesamtkosten niedrig.",
    detailsLowApr = "Niedriger effektiver Jahreszins. ",
    detailsLowInterestCost = "Niedrige Gesamtzinskosten.",
    discountsTradeIn = "Rabatte / Inzahlungnahme",
    displayName = "Deutsch",
    distribution = "Verteilung",
    downPayment = "Anzahlung",
    effectiveApr = "Effektiver Jahreszins",
    headerBalance = "Saldo",
    headerDate = "Datum",
    headerInterest = "Zinsen",
    headerMonth = "#",
    headerPayment = "Zahlung",
    headerPrincipal = "Kapital",
    hideDetails = "Details ausblenden",
    interest = "Zinsen",
    invalidData = "Ungültige Daten",
    loanAmountSupportingText = "Der gesamte Darlehensbetrag, einschließlich aller zusätzlichen Kosten.",
    loanDetails = "Kreditdetails",
    paymentSupportingText = "Ihre geschätzte monatliche Zahlung.",
    paymentComposition = "Zahlungszusammensetzung",
    percentSymbol = "%",
    principal = "Kapital",
    ratingBad = "Schlechter Deal",
    ratingExcellent = "Ausgezeichneter Deal",
    ratingFair = "Fairer Deal",
    ratingGood = "Guter Deal",
    ratingPoor = "Schlechter Deal",
    schedule = "Zeitplan",
    showDetails = "Details anzeigen",
    summaryBad = "Sehr ungünstig, wenn möglich vermeiden.",
    summaryExcellent = "Ausgezeichnete finanzielle Bedingungen.",
    summaryFair = "Faire Bedingungen, Verhandlung in Betracht ziehen.",
    summaryGood = "Gute Bedingungen, marktüblich.",
    summaryPoor = "Schlechte Bedingungen, hohe Kosten oder Zinssatz.",
    totalPaid = "Gesamt bezahlt",
    lockTaxRate = "Steuersatz sperren",
    unlockTaxRate = "Steuersatz entsperren",
    currencySymbol = "€",
    currency = "Währung",

    totalCreditAmount = "Gesamtkreditbetrag",
    taxAmount = "Steuer-/Abzugsbetrag",
    netAmountDisbursed = "Nettobetrag ausgezahlt", // Изчисляемо поле: totalCreditAmount - всички първоначални такси/данъци

    years = "Jahre",
    loanTermTotalMonths = "Kreditlaufzeit (Monate)", // Изчисляемо oder входно поле за общия срок

    monthlyInstallment = "Monatliche Rate",
    principalInstallment = "Kapitalrate",
    otherFees = "Sonstige Gebühren",

    insuranceCost = "Versicherungskosten",
    aprc = "Jährlicher Prozentsatz der Kosten (APRC)",
    totalAmountPayable = "Gesamtzahlbarer Betrag",
    prepaidFeeFixed = "Vorausbezahlte Gebühr (fester Betrag)",
    prepaidFeePercentage = "Vorausbezahlte Gebühr (Prozentsatz)",
    months = "Monate",
    description = "Dieser Analysator hilft Ihnen zu beurteilen, ob ein Kreditangebot für Sie vorteilhaft ist. Im Gegensatz zu Standardrechnern ist keine Eingabe eines Zinssatzes erforderlich. Stattdessen berechnet er den effektiven Jahreszins und die Gesamtkreditkosten basierend auf Zahlungen und Gebühren und liefert eine Deal-Bewertung sowie detaillierte Diagramme.",
    agree = "Zustimmen",
    information = "Informationen",
    errorDivisionByZero = "Division durch Null",
    errorNegativeResult = "Negatives Ergebnis",
    errorRateTooHigh = "Rate ist zu hoch",
    errorCalculation = "Bitte geben Sie korrekte Daten ein",
    errorCalculationOverflow = "Effektiver Jahreszins ist zu hoch, Berechnungsüberlauf.",
    errorTotalPaymentIsLessThanLoanAmount = "Erhaltener Betrag ist geringer als der Darlehensbetrag.",

    close = "Schließen",
    hi = "Hallo",
    guest = "Gast",
    account = "Konto",
    signInWithGoogle = "Mit Google anmelden",
    signOut = "Abmelden",
    settings = "Einstellungen",
    about = "Über",
    privacyPolicy = "Datenschutzerklärung",
    termsOfService = "Nutzungsbedingungen",

    language = "Sprache",
    theme = "Thema",
    light = "Hell",
    dark = "Dunkel",
    system = "System",
    toggleExpand = "Erweitern/Umschalten",
)
